export const hasPrivilege = (privilegeName) => {
    const privileges = JSON.parse(localStorage.getItem("Previlege")) || [];
    return privileges.some((priv) => priv.PL_Name === privilegeName);
};